export class AuthenticationModel {
  email: string;
  password: string;
  language?: 'tr' | 'en';

  // tenantKey body'de DEGIL — backend Tenant'i yalnizca ?tenant= query string'inden
  // okur ([JsonIgnore], bkz. AuthService.loginreal). Tenant dropdown'u olan
  // kurulumlarda secili deger loginreal() tarafindan URL'e eklenir.
  constructor(email: string, password: string, language?: 'tr' | 'en') {
    this.email = email;
    this.password = password;
    this.language = language;
  }
}
